import { OtpTextInput } from '../../../comps/OtpTextInput'
import { otp } from '../../../util/util'

export const otpForm = (): any => [
  {
    formItems: [
      {
        fieldName: 'otp',
        ComponentName: OtpTextInput,
        validationSchema: otp,
        maxLength: 6,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
